'use client';

import Link from 'next/link';

import type { Folder } from '@hub/common/src/types/cit-public-api';

import { addTestThemeToHref, getFolderLink } from '@hub/common/src/navigationUtils';
import { useCitOriginClient } from './CitOriginClientProvider';
import { useCitThemeClient } from './CitThemeProvider';
import { CitOrigin } from '@hub/common/src/types/cit-public-api';

interface FolderSidebarProps {
  accountId: string;
  folders: Folder[];
  selectedFolderId?: string;
}

export default function FolderSidebar({
  accountId,
  folders,
  selectedFolderId
}: FolderSidebarProps) {
  const citOrigin = useCitOriginClient();

  const { accountTheme } = useCitThemeClient();

  const bodyFont = accountTheme.bodyFont();

  const lineHeight = accountTheme.lineHeight();
  const letterSpacing = accountTheme.letterSpacing();

  return (
    <div
      key={accountId}
      className={`h-full bg-white px-1 overflow-y-auto ${
        citOrigin === CitOrigin.IFRAME ? 'border-r border-gray-200' : ''
      }`}
    >
      <Link
        href={addTestThemeToHref(
          getFolderLink(citOrigin, accountId, undefined),
          accountTheme.isTestTheme() ? accountTheme.getCompressedThemeConfig() : undefined
        )}
        className={`block px-4 py-2 mb-2 rounded-md ${
          !selectedFolderId ? 'bg-blue-100 text-blue-700' : 'hover:bg-gray-100'
        }`}
        prefetch={false}
        style={{ fontFamily: bodyFont, lineHeight, letterSpacing }}
      >
        ALL
      </Link>

      {folders.map((folder: Folder) => (
        <Link
          key={folder.id}
          href={addTestThemeToHref(
            getFolderLink(citOrigin, accountId, folder.slug || folder.id),
            accountTheme.isTestTheme() ? accountTheme.getCompressedThemeConfig() : undefined
          )}
          className={`block px-4 py-2 mb-2 rounded-md ${
            selectedFolderId === folder.slug || selectedFolderId === folder.id
              ? 'bg-blue-100 text-blue-700'
              : 'hover:bg-gray-100'
          }`}
          prefetch={false}
          style={{ fontFamily: bodyFont, lineHeight, letterSpacing }}
        >
          {folder.name}
        </Link>
      ))}
    </div>
  );
}
